<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-积分管理-积分明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="昵称">
          <el-input v-model="formInline.search" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="充值时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.value1" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="orderNo" label="订单号"></el-table-column>
          <el-table-column prop="user.nickName" label="微信昵称"></el-table-column>
          <el-table-column prop="avatarUrl" label="微信头像" width="70">
            <template slot-scope="scope">
              <img :src="scope.row.user?scope.row.user.avatarUrl:''" width="30" height="30" />
            </template>
          </el-table-column>
          <!-- <el-table-column prop="snapshot.plan_name" label="充值套餐"></el-table-column> -->
          <el-table-column prop="payPrice" label="支付金额">
            <template slot-scope="scope">
              <span style="color:red">￥{{scope.row.payPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="realMoney" label="到账数量"></el-table-column>
          <el-table-column prop="type" label="支付方式">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.type==20">套餐充值</el-tag>
              <el-tag type="danger" v-if="scope.row.type==10">自定义金额</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="付款状态">
            <template slot-scope="scope">
              <span v-if="scope.row.payStatus == 10" class="red">支付成功</span>
              <span v-if="scope.row.payStatus == 20" class="green">支付失败</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="充值时间"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import PlanApi from "@/api/balance.js";
export default {
  components: {},
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        search: "",
        value1: ""
      }
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      PlanApi.log(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;
		  console.log('self.tableData',self.tableData)
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.getTableList();
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/cash/plan/record.vue